import { render, staticRenderFns } from "./CreateCredentialProgram.vue?vue&type=template&id=5fd4470a&scoped=true"
import script from "./CreateCredentialProgram.vue?vue&type=script&lang=js"
export * from "./CreateCredentialProgram.vue?vue&type=script&lang=js"
import style0 from "./CreateCredentialProgram.vue?vue&type=style&index=0&id=5fd4470a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd4470a",
  null
  
)

export default component.exports